import { render, staticRenderFns } from "./OriginalCaption.vue?vue&type=template&id=68196688"
import script from "./OriginalCaption.vue?vue&type=script&lang=js"
export * from "./OriginalCaption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports